"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRoleSectionSubmitTimeRange = getRoleSectionSubmitTimeRange;
const common_1 = require("../common/common");
function isExplicitTime(value) {
    return !!value && value !== "0:00" && value !== "00:00";
}
function getRoleSectionSubmitTimeRange(role, selectedRoleSection) {
    if (selectedRoleSection && isExplicitTime(selectedRoleSection.from) && isExplicitTime(selectedRoleSection.to)) {
        return {
            from: selectedRoleSection.from,
            to: selectedRoleSection.to,
        };
    }
    const from = isExplicitTime(role?.from) ? role.from : "0:00";
    return {
        from,
        to: (0, common_1.durationToKitchenTime)((0, common_1.kitchenTimeToDuration)(from, "minutes") + 60, "minutes"),
    };
}
